<script>
import { Pie } from "vue-chartjs";

export default {
  extends: Pie,
  props: ["city"],
  mounted() {
    this.$store.state.schools.forEach((element) => {
      if (element["library"]) this.chartData.datasets[0].data[0]++;
      else this.chartData.datasets[0].data[1]++;
    });
    this.renderChart(this.chartData, this.options);
  },
  watch: {
    city: function () {
      if (this.city) {
        this.chartData.datasets[0].data = [0, 0];
        this.$store.getters.schoolsByCity(this.city).forEach((el) => {
          if (el["library"]) this.chartData.datasets[0].data[0]++;
          else this.chartData.datasets[0].data[1]++;
        });
        this.renderChart(this.chartData, this.options);
      }
    },
  },
  data() {
    return {
      chartData: {
        labels: ["Com Biblioteca", "Sem biblioteca"],
        datasets: [
          {
            backgroundColor: ["#394a61", "#7d96b5"],
            data: [0, 0],
          },
        ],
      },
      options: {
        legend: {
          display: true,
          position: "bottom",
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
};
</script>